module.exports = __webpack_public_path__ + "img/sideBarMiddle.a937ad1e.svg";